<template>
    <div class="page">
        <div class="head">
            <div class="province" @click="showProvince">
                <span>{{$store.state.areaInfo.province}}</span>
                <Icon :type="area?'ios-arrow-up':'ios-arrow-down'"/>
            </div>
            <div class="input">
                <input type="text" v-model="schValue">
                <div class="search" @click="goSearch">
                    <Icon type="ios-search-outline"/>
                </div>
            </div>
            <!-- 点击省份 -->
            <div class='select_area_pop' v-if="area">
    <div v-if="province.length>0">
        <!-- :class='item.id==xzsf?"yellow":""' -->
        <div v-for="(item,index) in province" :key="index"  @click='chooseAreaVal(item)' class="province">{{item.name}}</div>
    </div>
</div>
            <div class="choose" @click="showChoose">
                <span>筛选</span>
                <Icon type="ios-funnel"/>
            </div>
        </div>
        <!-- 广告位轮播 -->
        <div class="carousel">
            <van-swipe :autoplay="3000" indicator-color="white">
                <van-swipe-item v-for="(item,index) in bannerList" :key="index">
                    <img :src="item.ad_code">
                </van-swipe-item>
            </van-swipe>
        </div>
        <!-- 学校列表 -->
        <div class="school" v-for="(item,index) in schoolList" :key="index">
            <!-- <div>{{item.name}}</div> -->
            <div class="school-area">
                <span>{{item.name}}({{item.num}}所)</span>
            </div>
            <div class="more" @click="goSchoolList(item)">更多></div>
            <div class="school-list">
                <div class="school-list-item" v-for="(i,index) in item.child" :key="index" @click="goSchoolDetail(i)">
                    <div class="school-img">
                        <img :src="i.thumb" alt>
                    </div>
                    <p class="school-name">{{i.name}}</p>
                </div>
            </div>
        </div>
        <!-- 省份弹窗 -->
        <div class="area" v-if="area">
            <div :class="item.id === $store.state.areaInfo.pid?'area-province-on':'area-province' " v-for="(item,index) in areaList" :key="index" @click="chooseProvince(item)">
                {{item.name}}
            </div>
        </div>
        <!-- 筛选弹窗 -->
        <div class="type" v-if="choose">
            <h3>高校</h3>
            <div class="chooseType">
               <div :class="chooseTypeIdOne === item.id?'type-item-on':'type-item'" v-for="(item,index) in typeList" :key="index" @click="chooseTypeOne(item)">{{item.name}}</div>
            </div>
            <h3>类型</h3>
            <div class="chooseType">
                <div :class="chooseTypeIdTwo === item.id?'type-item-on':'type-item'" v-for="(item,index) in labelList" :key="index" @click="chooseTypeTwo(item)">{{item.name}}</div>
            </div>
            <div class="btnGroup">
                <button class="reset" @click="resetBtn">重置</button>
                <button class="sure" @click="submitBtn">确定</button>
            </div>
        </div>
    </div>
</template>

<script>
    import {httpGetRequest} from "../../axios/get";
    import {httpPostRequest} from "../../axios/post";

    import { httpPost,httpGet } from "../../axios/index";
    import {http_use} from "../../axios/test";

    export default {
        data() {
            return {
                items: 10,
                area: false,
                choose: false,
                chooseTypeIdOne:0,
                chooseTypeIdTwo:0,
                areaList: [],
                typeList: [],
                labelList:[],
                schoolList: [],
                bannerList: [],
                schValue:'',
                province:""//省份

            };
        },
        methods: {
            // 获取省份数据
            fetchProvince(){
                  httpPost( "/School/condition_school",  {})
                    .then(res => {
                        if (res.code === 1) {
                                this.province=res.region
                                 this.typeList=res.institution_type
                                  this.labelList=res.feature_label
                        }
                    });
            },
            // 点击切换省份
            chooseAreaVal(e){
                this.$store.state.areaInfo.province=e.name;
               this.$store.state.areaInfo.pid=e.id;
               this.area=false
               this.loadSchoolList() ;
            },
            // 搜索
            goSearch(){
                    this.$store.state.searchContent = this.schValue;
                    this.$router.push({ path: "/schoolList",query:{
                        name:this.schValue
                    } });
            },
            // 筛选重置
            resetBtn(){
                this.chooseTypeIdOne = '';
                this.chooseTypeIdTwo = '';
            },
            // 筛选提交
            submitBtn(){
              
                this.$router.push({path:"/schoolList",query:{
                    institution_type:this.$store.state.type.institution_type,
                        labe_id:this.$store.state.type.labe_id
                }})

            },
            chooseProvince(item) {
                this.$store.state.areaInfo.pid = item.id;
                this.$store.state.areaInfo.province = item.name;
                httpPost("/School/list_school",  {province: item.id})
                    .then(response => {
                        if (response.code === 1) {
                            this.schoolList = response.hotlist;
                            this.area = !this.area;
                        }
                    });
            },
            //选择高校类型
            chooseTypeOne(item){
               
                this.$store.state.type.institution_type = item.id;
                this.chooseTypeIdOne = item.id;
            },
            //选择类型（未完成）
            chooseTypeTwo(item){
             
                 this.$store.state.type.labe_id=item.id;
                 this.chooseTypeIdTwo = item.id;
            },
            //展示省份信息
            showProvince() {
                this.area = !this.area;
            },
            //展示筛选信息
            showChoose(item) {
                this.choose = !this.choose;
            },
            //前往学校列表
            goSchoolList(item) {
                // this.$store.state.areaInfo.cid = item.id;
                // this.$store.state.areaInfo.city = item.name;
                this.$router.push({path:"/schoolList",query:{city:item.id}});
            },
            //前往学校详情
            goSchoolDetail(i){
               
                var select=i.selecting;
                this.$store.state.schoolId = i.id;
                if(select==0){
                    this.$router.push({path:"/schoolDetail",query:{id:i.id}});
                }
                 if (select == 1){
                         this.$router.push({path:"/schoolSelectDetail",query:{id:i.id}});
                 }
                  if (select == 2){
                         this.$router.push({path:"/schoolSelectDetail",query:{id:i.id}});
                 }
               
            },
            //加载学校
            loadSchoolList() {
                httpPost( "/School/list_school",  {province: this.$store.state.areaInfo.pid})
                    .then(response => {
                      
                        if (response.code === 1) {
                            this.schoolList = response.hotlist;
                            // this.typeList = response.institution;
                            // this.labelList = response.labe;
                        }
                    });
            },
            //加载广告
            loadBannerList() {
                let obj = {};
                obj.province = 14234;
                httpPost( "/ad/rotation_school",  {province: this.$store.state.areaInfo.pid})
                    .then(response => {
                      
                        if (response.code === 1) {
                            this.bannerList = response.banlist;
                        }
                    });
            }
        },
        mounted() {
            this.fetchProvince();
            this.loadSchoolList();
            this.loadBannerList();
            //获取省市信息
            httpPost( "/School/list_school", {province: this.$store.state.areaInfo.pid})
                .then(response => {
                    if (response.code === 1) {
                        this.areaList = response.list;
                    }
                });
        }
    };
</script>

<style scoped>
.province{
    margin-right:4px;
} 
.select_area_pop {
    margin-top: 46px;
    background: #22d9d9;
    height: auto;
    overflow: hidden;
    padding-top: 10rpx;
    padding-left: 30rpx;
    padding-bottom: 20rpx;
    /**/
    position: fixed;
    z-index: 9999;
}

.select_area_pop div{
    width: 100rpx;
    margin-right: 10rpx;
    margin-left: 10rpx;
    margin-bottom: 10rpx;
    font-size: 28rpx;
    color: #fff;
    float: left;
}
.page{
    padding-bottom: 60px;
}
    .head {
        width: 100vw;
        display: flex;
        flex-flow: row;
        background: #22d9d9;
        color: #fff;
        line-height: 2rem;
        font-size: 1rem;
        position: relative;
    }

    .province,
    .choose {
        width: 5rem;
        line-height: 3rem;
        text-align: center;
        font-size: 1rem;
    }

    .input {
        flex: 1;
        margin: 0.5rem;
        position: relative;
        border-radius: 2rem;
        border: 0.08rem #fff solid;
    }

    .search {
        position: absolute;
        top: 0rem;
        bottom: 0;
        right: 0.5rem;
        font-size: 1.6rem;
    }

    .input input {
        border: none;
        background: #22d9d9;
        width: 80%;
        color: #fff;
        margin-left: 0.5rem;
        border-radius: 20px;

    }

    .school {
        position: relative;
    }

    .school-list {
        display: flex;
        overflow-y: hidden;
        overflow-x: scroll;
        padding-left: 0.625rem;
    }

    .school-list-item {
        margin-right: 8px;
    }

    .school-img {
        width: 25vw;
        height: 8rem;
    }

    .school-img img {
        width: 100%;
        height: 100%;
    }

    .school-area {
        padding: 0.5rem;
    }

    .more {
        position: absolute;
        top: 0.5rem;
        right: 0.5rem;
    }

    img {
        width: 100%;
        height: 100%;
    }

    .area {
        position: absolute;
        top: 3rem;
        width: 100vw;
        left: 0;
        background: #22d9d9;
        display: flex;
        flex-wrap: wrap;
        padding: 1rem 0;
    }
    .type{
        position: absolute;
        top: 3rem;
        width: 85vw;
        right: 0;
        background: #22d9d9;
        padding: 1rem 0;
    }

    .area-province-on,
    .area-province {
        color: #fff;
        border: 0.08rem #fff solid;
        margin-left: 1rem;
        width: 3rem;
        padding: 0.2rem;
        text-align: center;
        margin-top: 0.5rem;
        border-radius: 0.5rem;
    }

    .area-province-on {
        color: yellow;
    }
    h3{
        padding-left: 1rem;
        color: #fff;
    }
    .chooseType{
        display: flex;
        flex-wrap: wrap;
        padding-left: 1rem;
    }
    .type-item,.type-item-on{
        color: #fff;
        border: 0.08rem #fff solid;
        border-radius: 0.5rem;
        width: 3.5rem;
        text-align: center;
        padding: 0.2rem 0;
        margin:0.5rem 0.5rem;
    }
    .type-item-on{
        background: #fff;
        color: #22d9d9;
    }
    .btnGroup{
        display: flex;
        justify-content: center;
    }
    .btnGroup button{
        border: 1px solid #fff;
        border-radius: 0.5rem;
        width: 4rem;
        background: #22d9d9;
        color: #fff;
        font-size:0.8rem;
        line-height: 1.6rem;
        margin-top: 1rem;
    }
    .btnGroup .reset{
        margin-right: 1rem;
    }
</style>
